<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">Treatment List</h1>
	    </div>
	    <div class="col-sm-6 float-left add_user_btn">
	        <a routerLink="/create-treatment" class="btn btn-success" *ngIf="myrole=='1' || myrole=='8'">
		        <i class="fa fa-plus" aria-hidden="true"></i> Add Treatment
		    </a>
	    </div>

    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                    <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search"/></div>
                
                    <div class="col-sm-3">
                        <mat-select  placeholder="Treatment Category" [(ngModel)]="treatment_category_filter" (click)="setSearchValue('treatmentCategory')" multiple>
                            <input class="mySearchInput"
                            #treatmentCategorySearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatmentCategory')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentCategorySearch">
                            <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <button type="button" class="btn btn-primary ml-2 " (click)="loadTreatmentList(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
    </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadTreatmentList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 50px;">#</th>
                        <th>Treatment Category</th>
                        <th>Treatment Name</th>
                        <th>Cities</th>
                        <!-- <th>Treatment Image</th> -->
                        <th style="width: 100px;">Status</th>
                        <th style="width: 100px;">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let treatment of treatmentList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                            <span *ngIf="!treatment.categoryName">-</span>
                            <span *ngIf="treatment.categoryName">{{treatment.categoryName}}</span>

                        </td>
                        <td>{{treatment.name}}</td>
                        <td><span *ngFor="let city of treatment.available_cities" class="btn btn-secondary pt-0 pb-0 pl-1 pr-1 mr-1 mb-1">{{city}}</span></td>
                        <!-- <td>
                          <img class="profile_pic" *ngIf="treatment.image; else noImage" alt="treatmentImage" src="{{sc3Url}}{{treatment.image}}">
                          <ng-template #noImage>-</ng-template>
                          </td> -->
                        <td>
                        	<span class="badge bg-green-light" *ngIf="treatment.status=='1'">Active</span>
                        	<span class="badge bg-azure-light" *ngIf="treatment.status=='0'">In-Active</span>
                        </td>
                        <td>
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{treatment.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{treatment.id}}">
                                    <a class="dropdown-item" routerLink="/update-treatment/{{treatment.id}}"><i class="fa fa-pen"></i> Update</a>
                                </div>
                             </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !treatmentList.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Treatment not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


          </div>
</div>
